const routes = [
    {
        path: "/graduate/application/evaluation/exam/definition",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "graduateapplicationevaluationexam_index",
        }
    }
];

export default routes;
